import { css } from 'styled-components';

// 브레이크포인트 정의
const breakpoints = {
  mobile: '480px',
  tablet: '768px',
  laptop: '1024px',
  desktop: '1200px'
};

// 미디어 쿼리 헬퍼 함수들
export const media = {
  mobile: (...args) => css`
    @media (max-width: ${breakpoints.mobile}) {
      ${css(...args)};
    }
  `,
  tablet: (...args) => css`
    @media (max-width: ${breakpoints.tablet}) {
      ${css(...args)};
    }
  `,
  laptop: (...args) => css`
    @media (max-width: ${breakpoints.laptop}) {
      ${css(...args)};
    }
  `,
  desktop: (...args) => css`
    @media (max-width: ${breakpoints.desktop}) {
      ${css(...args)};
    }
  `
};

export default media;
